module.exports = __webpack_public_path__ + "img/Drug_Allergy-512.d5edc812.png";